/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */


import React, {Component, PropTypes} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';

import ScrollArea from '../../../../ScrollArea';

import {StubFunc, getScroll} from '../../../../../utils';
import {FetchAssetByIds} from '../../../../../actions/asset/action-asset';
import {CancelSubscription} from '../../../../../actions/purchase/actions-purchase';
import {OpenMessage, SetSettingsState} from '../../../../../actions/common/actions-common';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';
import Tooltip from 'rc-tooltip';

import moment from 'moment';
import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';
import _some from 'lodash/some';
import _isNil from 'lodash/isNil';
import _at from 'lodash/at';
import _get from 'lodash/get';

class SubscriptionProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-package-poster-profile.png`,
      streamUrl: ''
    };
  }

  componentDidMount() {

    if (this.props.subscription.id) {

      lh.models.asset.methods
        .getPosterUrl(this.props.subscription, {
          crop: {x: 270, y: 270},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-package-poster-profile.png`});
        });

      this.props.FetchAssetByIds(_get(this.props.subscription, 'assets', []));
    }
  }

  componentWillReceiveProps(newProps) {

    if (_get(newProps.subscription, 'id') && _get(newProps.subscription, 'id') !== _get(this.props.subscription, 'id')) {

      lh.models.asset.methods
        .getPosterUrl(newProps.subscription, {
          crop: {x: 270, y: 270},
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-package-poster-profile.png`});
        });
    }

    if (!_isEqual(_get(newProps.subscription, 'assets', []), _get(this.props.subscription, 'assets', []))) {
      this.props.FetchAssetByIds(_get(newProps.subscription, 'assets', []));

    } else if (_some(_get(newProps.subscription, 'assets', []), _isNil)) {

      this.props.FetchAssetByIds(_get(newProps.subscription, 'assets', []));
    }
  }

  _closeProfile() {

    this.props.onClose();
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: this.props.subscription.id,
      offers: [this.props.subscription],
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  _unsubscribe() {

    if (_get(this.props, 'subscription.ent.id')) {
      this.props.OpenMessage({
        type: 'common',
        title: Translate.translator('profile.subscription.are_you_sure'),
        body: Translate.translator('profile.subscription.cancel_desc') + ' "' + _get(this.props.subscription, 'name', '') + '"? ' + Translate.translator('profile.subscription.re_subscribe'),
        actions: [
          {
            title: 'yes',
            func: () => {

              this.props.CancelSubscription(this.props.subscription.ent.id, this.props.subscriptionId);
            }
          },
          {
            title: 'no',
            func: () => {
            }
          }
        ]
      });

    }
  }

  _renderOffer() {
    if (this.props.subscription.is_purchased) {

      let entData = moment.unix(this.props.subscription.ent.ent_expiration_time);

      return (<div className="offer">
        <strong><Translate content="profile.subscription.expires" />:</strong>
        <div className="mt">{entData.format('LLL')}</div>
      </div>)
    }

    var offer = this.props.subscription;

    return (
      <div className="offer">
        <div className="offer-price color-grey pl-">
          { _get(offer, 'right_params.duration') + ' ' + _get(offer, 'right_params.duration_unit') + '(s)' }
        </div>
        <div className="offer-price profile-bigtext mt">
          <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
          <span>{_get(offer, 'billing_params.price') / 100}</span>
        </div>
      </div>
    );
  }

  _renderIncluded() {

    return _get(this.props, 'assets', []).map((asset, index) => {

      return (!!asset && <div key={'asset_' + asset.id}><Link to={'/asset/' + asset.id}>
        {index + 1}. {asset.title}
      </Link></div>);
    });
  }

  _renderEnt() {
    let entData = moment.unix(_get(this.props, 'subscription.ent.subscription_period_end'));

    return (<div className="profile-r">
      <div className="offer">
        <strong>{_get(this.props.subscription, 'ent.subscription_cancel_at_end', false) ? <Translate content="profile.subscription.expires" /> : <Translate content="profile.subscription.subscription_period_end" />}:</strong>
        <div style={{marginTop: '15px'}}> {entData.format('LLL')} </div>
      </div>
    </div>);
  }

  render() {
    if (!_get(this.props.subscription, 'id')) return <div className="profile movie-inf-example movie-inf-profile bg-black radius"><DivLoader loading={true} /></div>;

    let startData = moment.unix(_get(this.props, 'subscription.ent.create_time'));

    return (<div className="profile movie-inf-example movie-inf-profile bg-black radius">
      <DivLoader loading={this.props.inProgress || this.props.cancelInProgress} />
      <div className="profile-cols relative">
        <div className="block-2">
          <div className="crow no-gutter pointer pr">
            <img id="profile_poster" src={this.state.picture} alt="" style={{width: '270px', height: '270px'}} />
          </div>
        </div>
        <div className="block-2">
          <div className="profile-r pr">
            <div className="profile-title" style={{whiteSpace: 'normal'}}>
              {_get(this.props.subscription, 'name', '')}
            </div>
            <ScrollArea
              speed={0.8}
              className="profile-text"
              horizontal={false}
              smoothScrolling={true}>
              <div>{_get(this.props.subscription, 'description', '')}</div>
            </ScrollArea>
          </div>
        </div>
        <div className="block-2">
          <div className="profile-r pr">
            <div className="subscription-title-3">
              <strong><Translate content="profile.packages.included" />:</strong>
            </div>
            <ScrollArea
              speed={0.8}
              className="profile-included"
              horizontal={false}
              smoothScrolling={true}>
              <div>{this._renderIncluded()}</div>
            </ScrollArea>
          </div>
        </div>
        <div className="block-2">
          { !this.props.subscription.is_purchased && !this.props.subscription.is_available &&
          <div className="profile-r pr purchase-container">
            {this._renderOffer()}
            {!this.props.subscription.is_free && <div className="purchase-ico mt hover" onClick={this._showOffers.bind(this)}>
              <i className="ic ic-shopping-cart"></i>
            </div>}
          </div>}
          {!!this.props.subscription.is_purchased && this._renderEnt()}
        </div>
        <div className="block-1 col-last">
          <div className="profile-r">
            <div className="profile-actions pr">
              {!!this.props.subscription.is_purchased && <div className="mt-">
                <div className="color-grey pv-"><Translate content="profile.subscription.details" /></div>
                <div id="screen">
                  <Tooltip
                    placement="top"
                    destroyTooltipOnHide={true}
                    overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p">
                      <Translate content="profile.subscription.status" />:
                      <div className="mt-">
                        <Translate content={`profile.subscription.subscription_states.${_get(this.props.subscription, 'ent.subscription_state')}`}/>
                      </div>
                      <br />
                      <Translate content="profile.subscription.first_payment" />:
                      <div className="mt-">{startData.format('LLL')}</div>
                    </div>}>
                    <a className="hover">
                      <i className="ic ic-info-circle ic-24px"></i>
                    </a>
                  </Tooltip>
                </div>
              </div>}
              {!!this.props.subscription.is_purchased && !_get(this.props.subscription, 'ent.subscription_cancel_at_end', false) && <div className="mt-">
                <div className="color-grey pv-"><Translate content="profile.subscription.cancel" /></div>
                <div id="screen">
                  <a className="hover share-to-device" onClick={this._unsubscribe.bind(this)}>
                    <i className="ic ic-forbidden ic-24px"></i>
                  </a>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
      <a className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
    </div>);
  }
}

SubscriptionProfile.propTypes = {
  subscriptionId: PropTypes.number.isRequired,
  subscription: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

SubscriptionProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from Subscription Profile')
};

const mapStateToProps = function ({assets, auth: {user}, collections: {offers}, purchases: {cancel}}, ownProps) {
  let subscription = _find(offers.collection, {id: ownProps.subscriptionId});

  return {
    user: user,
    assets: _at(assets, _get(subscription, 'assets', [])),
    subscription: subscription,
    cancelInProgress: _get(cancel, _get(ownProps, 'subscriptionId') + '.cancelInProgress', false)
  };
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({
    FetchAssetByIds,
    OpenMessage,
    SetSettingsState,
    CancelSubscription
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/Subscription/subscription-profile.js